module.exports = __webpack_public_path__ + "img/master_kategori.af23197a.png";